import { Outlet } from 'react-router-dom'

import { DashboardLayout } from '@components'
import { TicketNotifProvider, HandleTicketModalProvider } from '@contexts'

import { CarrierMenu } from './CarrierMenu'

const selectOptions = [{ value: 'ticketId', label: 'Trip ID' }]

const TplRouter = () => {
  return (
    <HandleTicketModalProvider>
      <DashboardLayout menu={CarrierMenu} searchSelectOptions={selectOptions}>
        <TicketNotifProvider>
          <Outlet />
        </TicketNotifProvider>
      </DashboardLayout>
    </HandleTicketModalProvider>
  )
}
export { TplRouter }
